var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkngPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 422,
    height: 202
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bkng-pending_svg__a",
    x1: "100%",
    x2: "0%",
    y1: "49.757%",
    y2: "50.243%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F89D19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3C852"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bkng-pending_svg__b",
    x1: "67.56%",
    x2: "0%",
    y1: "48.057%",
    y2: "59.457%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5B83D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F3C852"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bkng-pending_svg__a)",
    d: "M232.58 5.35h14.72c18.168 0-12.249-5.184 0-5.184h66.485c62.024 0 82.89.471 55.874 5.183-27.017 4.712-23.802 1.414 24.751 0 48.554-1.413 25.843 9.732-28.968 9.732-54.81 0-207.465 3.777-178.722 0 19.162-2.518 48.054-4.724 86.677-6.618L232.58 5.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bkng-pending_svg__b)",
    d: "M.108 201.279c4.053-33.333 24.54-50 61.457-50 55.377 0 59.925-47.25 97.161-65.872 37.237-18.623 51.079 12.29 91.596-15.518 40.518-27.808 70.38-51.625 113.958-29.877 29.052 14.498 33.862 68.254 14.43 161.267H.108z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#F8FCFE",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.555 45.689v4.734M128.988 49.26l-3.68 2.98M130.836 57.334l-4.613-1.065M125.697 63.783l-2.076-4.254M117.413 63.783l2.076-4.254M112.274 57.334l4.613-1.065M114.121 49.26l3.68 2.98"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.566 74.859)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F493F",
    d: "M.561 57.6h117.12v63.36a3.2 3.2 0 01-3.2 3.2H3.761a3.2 3.2 0 01-3.2-3.2V57.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.16,
    height: 93.44,
    x: 12.8,
    y: 0.402,
    fill: "#F8FCFE",
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFCB82",
    d: "M25.88 47.141h66v4h-66zm10 10.083h46v4h-46zm5 10h36v4h-36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8A01D",
    d: "M117.681 57.6v63.36a3.2 3.2 0 01-3.2 3.2H3.928a.64.64 0 01-.318-1.195L117.681 57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8A01D",
    d: "M.561 57.6v63.36a3.2 3.2 0 003.2 3.2h110.553a.64.64 0 00.318-1.195L.562 57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9AF1A",
    d: "M59.12 91.156l55.512 31.809a.64.64 0 01-.318 1.195H3.928a.64.64 0 01-.318-1.195l55.51-31.81z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 180.566,
    cy: 99.127,
    r: 13.6,
    fill: "#F5A623"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.03 97.782v7.184a.854.854 0 01-1.706 0v-7.184a.853.853 0 011.706 0zm.324-3.601c0 .158-.032.308-.097.45-.064.144-.15.27-.258.377-.108.108-.234.193-.38.254s-.298.092-.455.092c-.158 0-.306-.03-.446-.092a1.2 1.2 0 01-.626-.63 1.136 1.136 0 01-.092-.45 1.183 1.183 0 01.346-.836c.108-.108.231-.193.372-.254a1.153 1.153 0 01.9 0c.146.061.272.146.38.254.108.108.194.233.258.376.065.143.097.296.097.46z",
    fill: "#3B385E",
    fillRule: "nonzero",
    stroke: "#3B385E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 94.967,
    r: 4,
    fill: "#F8FCFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.401,
    cy: 92.967,
    r: 2,
    fill: "#F8FCFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.366,
    cy: 50.859,
    r: 2.6,
    fill: "#F8FCFE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.868,
    cy: 38.659,
    r: 6.2,
    stroke: "#F8FCFE",
    strokeWidth: 3
  }))));
}
export default SvgBkngPending;